import * as Yup from "yup";
import { yupPassword, yupRepeatPassword } from "./yupRules";
const onlyLatinAndGreekLetters = /^[a-zA-Z\u0370-\u03FF]+$/;
const countryPhoneCode = /^\+?\d{2,3}[\s\d]*$/; // Ensures correct format with country code
const nonDigits = /\D/g;

export const registerSchema = (t) =>
  Yup.object().shape({
    firstName: Yup.string()
      .matches(onlyLatinAndGreekLetters, t("Register.OnlyLetters"))
      .required(t("Register.NameError")),
    lastName: Yup.string()
      .matches(onlyLatinAndGreekLetters, t("Register.OnlyLetters"))
      .required(t("Register.LastNameError")),
    // region: Yup.string().when("role", {
    //   is: (value) => value === USER_ROLES.AGRONOMIST,
    //   then: Yup.string().required(t("Register.RegionError")),
    //   otherwise: Yup.string().nullable(),
    // }),
    email: Yup.string()
      .email(t("Register.EmailError"))
      .required(t("Register.EmailRequiredError")),
    phone: Yup.string()
      .matches(countryPhoneCode, t("Register.Phone"))
      .test("is-valid-number", t("Register.PhoneLength"), (value) => {
        if (!value) return false;
        const digitsOnly = value.replace(nonDigits, ""); // Remove all non-digit characters
        if (value.startsWith("+")) {
          return digitsOnly.length === 12 || digitsOnly.length === 13;
        }
        return digitsOnly.length === 10; // Validate that there are exactly 10 digits
      }),
    password: yupPassword(t),
    repeatPassword: yupRepeatPassword(t),
    term1: Yup.bool().oneOf([true], t("Register.Term1Error")),
    term2: Yup.bool().oneOf([true], t("Register.Term2Error")),
  });
